@if (user) {
  <div class="container single-view" id="edit-user">
    <div class="row">
      <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
        <div id="pre-header-wr">
          <a data-testid="back-btn" appBack [fallbackUrl]="'/users/' + userId" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'USERS.BTN_BACK_TO_USER' | translate }}</a>
        </div>
      </div>
      <div class="col-12">
        <div id="view-header-wr">
          <div class="title-wr">
            <h1 data-testid="edit-user-title"  class="section-title">{{ 'USER_UPDATE.TITLE' | translate }}</h1>
          </div>
        </div>
        <hr role="presentation" class="w-full mb-3 mt-6 border-t">
        <div class="view-content-wr">
          <div class="row">
            <div class="flex flex-col col-12 mb-2 text-wr">
              <!-- main content -->
              <form class="mt-0" [formGroup]="userForm" data-testid="edit-user-form">
                <div class="row">
                  <div class="flex flex-col col-12 mb-4">
                    <h2 data-testid="edit-user-details" class="border-b pb-3">{{ 'USER_UPDATE.USER_DETAILS' | translate }}</h2>
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-user-field-firstname" class="block text-sm" for="firstname">{{ 'USER_UPDATE.FIRST_NAME' | translate }} <i
                    class="icon-required-field"></i></label>
                    <input data-testid="edit-user-firstname-input" type="text" formControlName="firstname" autocomplete="off">
                    @if (userForm.get('firstname')?.invalid && (userForm.get('firstname')?.touched || userForm.get('firstname')?.dirty)) {
                      <small data-testid="firstname-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                    }
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-user-field-romanisedfirstname" class="block text-sm" for="romanisedFirstName">{{ 'USER_UPDATE.ROMANIZED_FIRST_NAME' | translate }}</label>
                    <input data-testid="edit-user-romanisedfirstname-input" type="text" formControlName="romanisedFirstName" autocomplete="off">
                    @if (userForm.get('romanisedFirstName')?.invalid && (userForm.get('romanisedFirstName')?.dirty || userForm.get('romanisedFirstName')?.touched)) {
                      @if (userForm.get('romanisedFirstName')?.errors?.['invalidCharacters']) {
                        <small data-testid="romanisedfirstname-format" class="p-error">
                          {{ 'USER_UPDATE.FORMAT_LATIN_CHARSET_ONLY_ALLOWED' | translate }}
                        </small>
                      }
                    }
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-user-field-lastname" class="block text-sm" for="lastname">{{ 'USER_UPDATE.LAST_NAME' | translate }} <i
                    class="icon-required-field"></i></label>
                    <input data-testid="edit-user-lastname-input" type="text" formControlName="lastname" autocomplete="off">
                    @if (userForm.get('lastname')?.invalid && (userForm.get('lastname')?.touched || userForm.get('lastname')?.dirty)) {
                      <small data-testid="lastname-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                    }
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-user-field-romanisedlastname" class="block text-sm" for="romanisedLastName">{{ 'USER_UPDATE.ROMANIZED_LAST_NAME' | translate }} </label>
                    <input data-testid="edit-user-romanisedlastname-input" type="text" formControlName="romanisedLastName" autocomplete="off">
                    @if (userForm.get('romanisedLastName')?.invalid && (userForm.get('romanisedLastName')?.dirty || userForm.get('romanisedLastName')?.touched)) {
                      @if (userForm.get('romanisedLastName')?.errors?.['invalidCharacters']) {
                        <small data-testid="romanisedlastname-format" class="p-error">
                          {{ 'USER_UPDATE.FORMAT_LATIN_CHARSET_ONLY_ALLOWED' | translate }}
                        </small>
                      }
                    }
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3 disabled">
                    <label data-testid="edit-user-field-username" class="block text-sm" for="username">{{ 'USER_UPDATE.USERNAME' | translate }} <i
                    class="icon-required-field"></i></label>
                    <input data-testid="edit-user-username-input" type="text" formControlName="username" autocomplete="off">
                    @if (userForm.get('username')?.dirty || userForm.get('username')?.touched) {
                      @if (userForm.get('username')?.hasError('required')) {
                        <small data-testid="username-mandatory" class="p-error">
                          {{ 'USER_CREATE.USERNAME_REQUIRED' | translate }}
                        </small>
                      }
                      @if (userForm.get('username')?.hasError('minlength')) {
                        <small data-testid="username-format-length" class="p-error">
                          {{ 'USER_CREATE.USERNAME_MIN_LENGTH' | translate }}
                        </small>
                      }
                      @if (userForm.get('username')?.hasError('spacesFound')) {
                        <small data-testid="username-format-spaces" class="p-error">
                          {{ 'USER_CREATE.USERNAME_CANNOT_CONTAIN_SPACES' | translate }}
                        </small>
                      }
                      @if (userForm.get('username')?.hasError('usernameTaken')) {
                        <small data-testid="username-taken" class="p-error">
                          {{ 'USER_CREATE.USERNAME_TAKEN' | translate }}
                        </small>
                      }
                    }
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-user-field-roles" class="block text-sm" for="roles">{{ 'USER_UPDATE.ROLE' | translate }} <i
                    class="icon-required-field"></i></label>
                    <app-custom-dropdown
                      data-testid="roles"
                      [placeholder]="'USER_UPDATE.SELECT_A_ROLE' | translate"
                      optionLabel="text"
                      optionValue="id"
                      [isMultiselect]="false"
                      [showSelectionChips]="true"
                      [showClear]="true"
                      [searchMode]="'remote'"
                      [pageSize]="rolesRowsPerPageOption"
                      [totalCount]="rolesTotalRecords"
                      [totalPages]="getTotalPages(rolesTotalRecords, rolesRowsPerPageOption)"
                      [options]="rolesList"
                      formControlName="roles"
                      (onLazyLoad)="onLazyLoadRoles($event)">
                    </app-custom-dropdown>
                    @if (userForm.get('roles')?.invalid && userForm.get('roles')?.touched) {
                      <small data-testid="roles-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                    }
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-user-field-language" class="block text-sm" for="language">{{ 'USER_UPDATE.LANGUAGE' | translate }}</label>
                    <app-custom-dropdown
                      data-testid="selector-input-languages"
                      [optionTestIdPrefix]="'listbox-item-'"
                      [options]="languages"
                      optionLabel="language"
                      optionValue="code"
                      [isMultiselect]="false"
                      [showSelectionChips]="true"
                      [showSearchbox]="true"
                      [showClear]="false"
                      [searchMode]="'local'"
                      [pageSize]="10"
                      [placeholder]="'USER_UPDATE.LANGUAGE_DROPDOWN_PLACEHOLDER' | translate"
                      formControlName="selectedLanguage">
                    </app-custom-dropdown>
                    @if (userForm.get('selectedLanguage')?.dirty || userForm.get('selectedLanguage')?.touched) {
                      <div class="error-hint-wr"
                        >
                        @if (userForm.get('selectedLanguage')?.hasError('required')) {
                          <small data-testid="language-invalid" class="p-error">
                            {{ 'USER_UPDATE.VALIDATE_LANGUAGE' | translate }}
                          </small>
                        }
                      </div>
                    }
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-user-field-email" class="block text-sm" for="email">{{ 'USER_UPDATE.EMAIL' | translate }} <i
                    class="icon-required-field"></i></label>
                    <input data-testid="edit-user-email-input" type="text" formControlName="email" tabindex="16" autocomplete="off">
                    @if (userForm.get('email')?.invalid && (userForm.get('email')?.dirty || userForm.get('email')?.touched)) {
                      @if (userForm.get('email')?.hasError('required')) {
                        <small data-testid="email-mandatory" class="p-error">{{ 'YOUR_ACCOUNT.VALIDATE_EMAIL'
                        | translate }}</small>
                      }
                      @if (userForm.get('email')?.errors?.['invalidEmail']) {
                        <small data-testid="email-format" class="p-error">{{
                        'YOUR_ACCOUNT.VALIDATE_EMAIL_SYNTAX' | translate }}</small>
                      }
                    }
                  </div>
                </div>
                <div class="row">
                  <div class="flex flex-col col-12 mb-4 mt-4">
                    <h2 data-testid="edit-user-markets-retailers-details" class="border-b pb-3">{{ 'USER_UPDATE.USER_RETAILERS_AND_MARKETS' | translate }}</h2>
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3" [ngClass]="{ 'disabled': !isRoleSelected() || !isMarketsFieldDisabled }">
                    <label data-testid="edit-user-field-markets" class="block text-sm" for="markets">{{ 'USER_UPDATE.ASSIGN_MARKETS' | translate }}</label>
                    <app-custom-dropdown
                      data-testid="markets"
                      [placeholder]="'USER_UPDATE.SELECT_MARKET' | translate"
                      [fieldLabel]="'USER_UPDATE.ASSIGN_MARKETS' | translate"
                      optionLabel="text"
                      optionValue="id"
                      [isMultiselect]="true"
                      [showSelectionChips]="true"
                      [showClear]="true"
                      [searchMode]="'remote'"
                      [pageSize]="marketsRowsPerPageOption"
                      [totalCount]="marketsTotalRecords"
                      [totalPages]="getTotalPages(marketsTotalRecords, marketsRowsPerPageOption)"
                      [options]="marketsList"
                      formControlName="markets"
                      (onLazyLoad)="onLazyLoadMarkets($event)">
                    </app-custom-dropdown>
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3" [ngClass]="{'disabled': !isRoleSelected() ||!isRetailersFieldDisabled }">
                    <label data-testid="edit-user-field-retailers" class="block text-sm" for="stores">{{ 'USER_UPDATE.ASSIGN_STORES' | translate }}</label>
                    <app-custom-dropdown
                      data-testid="retailers"
                      [placeholder]="'USER_UPDATE.SELECT_STORE' | translate"
                      [fieldLabel]="'USER_UPDATE.ASSIGN_STORES' | translate"
                      optionLabel="text"
                      optionValue="id"
                      [isMultiselect]="true"
                      [showSelectionChips]="true"
                      [showClear]="true"
                      [searchMode]="'remote'"
                      [pageSize]="storesRowsPerPageOption"
                      [totalCount]="storesTotalRecords"
                      [totalPages]="getTotalPages(storesTotalRecords, storesRowsPerPageOption)"
                      [options]="storesList"
                      formControlName="stores"
                      (onLazyLoad)="onLazyLoadStores($event)">
                    </app-custom-dropdown>
                  </div>
                </div>
                <div class="row">
                  <div class="flex flex-col col-12 mb-4">
                    <h2 data-testid="edit-user-password-details" class="border-b pb-3">{{ 'USER_UPDATE.ACCOUNT_PASSWORD' | translate }}</h2>
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mt-1">
                    <p data-testid="edit-user-field-allowpasswordchange" class="mb-2 label">{{ 'USER_UPDATE.ALLOW_PASSWORD_CHANGE' | translate }}</p>
                    <div class="flex flex-row">
                      <span data-testid="edit-user-foreign-radio-allowpasswordchange-yes" class="inline-flex mr-6">
                        <p-radioButton name="allowPasswordChange" value="true" formControlName="allowPasswordChange" inputId="yes" />
                        <label for="yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</label>
                      </span>
                      <span data-testid="add-user-foreign-radio-allowpasswordchange-no" class="inline-flex mr-2">
                        <p-radioButton name="allowPasswordChange" value="false" formControlName="allowPasswordChange" inputId="no" />
                        <label for="no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</label>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mt-6 mb-4 pt-8 border-t">
                    <div class="flex items-center justify-end gap-3">
                      <button data-testid="edit-user-update-user-button" class="btn primary-btn" [disabled]="isSubmitDisabled()" (click)="submitForm()">{{
                      'USER_UPDATE.BTN_UPDATE_USER' | translate }}</button>
                    </div>
                  </div>
                </div>
              </form>
              <!-- /main content -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
